var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570",
    transform: "translate(-244 -1369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3565",
    "data-name": "Group 3565",
    transform: "translate(9.622 -8.384)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_915",
    "data-name": "Line 915",
    x2: 21.348,
    y2: 21.267,
    transform: "translate(248.907 1392)",
    fill: "none",
    stroke: "#1e1c40",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_916",
    "data-name": "Line 916",
    x1: 21.187,
    y2: 21.267,
    transform: "translate(248.907 1392)",
    fill: "none",
    stroke: "#1e1c40",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    transform: "translate(244 1419) rotate(-90)",
    fill: "none",
    stroke: "#1e1c40",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e2f886e3b48c8f7f5509f43f8ca37595.svg";
export { ForwardRef as ReactComponent };